<template>
  <v-card :loading="loading">
    <v-card-title>
      <span class="headline">Oanda API key</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="apikey"
              color="#4dbac0"
              name="oandakey"
              label="Your Oanda API key"
              
            ></v-text-field>

            <div class="errors">
              <li v-for="(error, index) in errors" :key="index">{{error}}</li>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn disabled color="blue darken-1" text @click="info">
        <v-icon>help_outline</v-icon>
      </v-btn>
      <v-btn color="blue darken-1" text @click="save">
        <v-icon>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  name: "modal",
  data() {
    return {
      name: "addOandaKey",
      errors: new Array(),

      loading: false
    };
  },
  asyncComputed: {
    apikey: {
      get() {
        return new Promise((resolve, reject) => {
          axios
            .post("https://tradeinpool.com:3001/api/request/apikey/", {
              method: "oanda",
            })
            .then(response => {
              resolve(response.data);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      default: null
    }
  },
  methods: {
    close() {
      this.$emit("close", this.name);
    },
    save() {
      this.loading =true
      this.errors = [];
      if(this.apikey.length < 200){
      axios
            .post("https://tradeinpool.com:3001/api/update/apikey/", {
              method: "oanda",
              key: this.apikey,
            })
            .then(() => {
              this.loading =false
              this.$emit("close", this.name);
              
            })
            .catch(err => {
              this.loading =false
              this.errors.push(err.response.data.error)
            });

      }else{
        alert("apikey too long")
      }
      
    }
  }
};
</script>

<style scoped>
.headline {
  color: #4dbac0;
}
</style>